function scrollStep(track: HTMLElement): number {
  const first = track.querySelector<HTMLElement>(".carousel-track__item");
  const w = first?.offsetWidth ?? track.clientWidth;
  return Math.min(w + 16, track.clientWidth * 0.9);
}

export function initCarousels(): void {
  for (const shell of document.querySelectorAll<HTMLElement>("[data-carousel-shell]")) {
    const track = shell.querySelector<HTMLElement>("[data-carousel-track]");
    const prev = shell.querySelector<HTMLButtonElement>("[data-carousel-prev]");
    const next = shell.querySelector<HTMLButtonElement>("[data-carousel-next]");
    if (!track) continue;

    prev?.addEventListener("click", () => {
      track.scrollBy({ left: -scrollStep(track), behavior: "smooth" });
    });
    next?.addEventListener("click", () => {
      track.scrollBy({ left: scrollStep(track), behavior: "smooth" });
    });
  }
}
